const LEGACY_PRIVATE_PHOTO_CACHE_PREFIX = "manutio-photos";

type CacheStorageForCleanup = Pick<CacheStorage, "keys" | "delete">;

function browserCacheStorage(): CacheStorageForCleanup | undefined {
  return typeof globalThis.caches === "undefined" ? undefined : globalThis.caches;
}

export async function clearLegacyPrivatePhotoCaches(
  cacheStorage: CacheStorageForCleanup | undefined = browserCacheStorage(),
) {
  if (!cacheStorage) return;

  const cacheNames = await cacheStorage.keys();
  await Promise.all(
    cacheNames
      .filter((cacheName) => cacheName.startsWith(LEGACY_PRIVATE_PHOTO_CACHE_PREFIX))
      .map((cacheName) => cacheStorage.delete(cacheName)),
  );
}
